(function () {
  if (window.__customBoxNowCartInitialized) {
    return;
  }

  window.__customBoxNowCartInitialized = true;

  var CART_SECTION_SELECTOR = '[data-section-type="cart-template"]';
  var CHECKOUT_BUTTON_SELECTOR = '.js-cart-button[name="checkout"]';
  var TERMS_CHECKBOX_SELECTOR = '.js-terms-and-conditions-checkbox';
  var BUTTON_MESSAGE_SELECTOR = '.js-cart-footer-button-message';
  var LOCKER_MAP_BUTTON_SELECTOR = '.js-cart-locker-map-button';
  var LOCKER_MAP_BUTTON_LABEL_SELECTOR = '.js-cart-locker-map-button-label';
  var LOCKER_MAP_SUMMARY_SELECTOR = '.js-cart-locker-map-summary';
  var LOCKER_MODAL_SELECTOR = '#CartLockerModal';
  var LOCKER_MODAL_CONTENT_SELECTOR = '.js-cart-locker-modal-content';
  var LOCKER_INPUT_SELECTOR = '#tp-box-now-selected-locker-id';
  var LOCKER_SELECTION_SELECTOR = '.tp-box-now-locker-selection';
  var LOCKER_DETAILS_SELECTOR = '.tp-box-now-locker-selection__details';
  var LOCKER_UNSELECT_BUTTON_SELECTOR = '.tp-box-now-locker-selection__details-unselect-btn';
  var LOCKER_APP_SECTION_HIDDEN_CLASS = 'cart-locker-app-section--hidden';
  var LOCKER_APP_COPY_HIDDEN_CLASS = 'cart-locker-app-copy--hidden';
  var KNOWN_LOCKER_LAUNCHER_SELECTORS = [
    '.boxnow-map-widget-button',
    '.boxnow-widget-button',
    '[class*="boxnow-map-widget-button"]',
    '[class*="boxnow-widget-button"]',
    '[data-boxnow-map-widget-button]',
    '[data-box-now-map-widget-button]',
    '[data-boxnow-widget-button]',
    '[data-box-now-widget-button]',
    '[id*="boxnow"][id*="button"]',
    '[class*="tp-box-now"][class*="button"]'
  ];
  var FALLBACK_DISABLED_CLASS = 'is-disabled';
  var lockerMutationObserver = null;
  var lockerModalToggle = null;
  var lockerAppSectionPlaceholder = null;
  var observedLockerNode = null;
  var syncQueued = false;

  function getCartSection() {
    return document.querySelector(CART_SECTION_SELECTOR);
  }

  function getCheckoutButton() {
    var cartSection = getCartSection();

    if (!cartSection) {
      return null;
    }

    return cartSection.querySelector(CHECKOUT_BUTTON_SELECTOR);
  }

  function getLockerInput() {
    return document.querySelector(LOCKER_INPUT_SELECTOR);
  }

  function getLockerMapButton() {
    var cartSection = getCartSection();

    if (!cartSection) {
      return null;
    }

    return cartSection.querySelector(LOCKER_MAP_BUTTON_SELECTOR);
  }

  function getLockerMapSummary() {
    var cartSection = getCartSection();

    if (!cartSection) {
      return null;
    }

    return cartSection.querySelector(LOCKER_MAP_SUMMARY_SELECTOR);
  }

  function getLockerModal() {
    return document.querySelector(LOCKER_MODAL_SELECTOR);
  }

  function getLockerModalContent() {
    var lockerModal = getLockerModal();

    if (!lockerModal) {
      return null;
    }

    return lockerModal.querySelector(LOCKER_MODAL_CONTENT_SELECTOR);
  }

  function getLockerAppSection() {
    var lockerInput = getLockerInput();
    var lockerLauncher = getLockerLauncher();
    var lockerAppElement = lockerInput || lockerLauncher;

    if (!lockerAppElement || !lockerAppElement.closest) {
      return null;
    }

    return lockerAppElement.closest('[id^="shopify-section-"]');
  }

  function getLockerSelectionRoot(lockerInput) {
    if (!lockerInput || !lockerInput.closest) {
      return lockerInput;
    }

    return lockerInput.closest(LOCKER_SELECTION_SELECTOR) || lockerInput;
  }

  function normalizeLockerValue(rawValue) {
    if (rawValue == null) {
      return '';
    }

    return String(rawValue).trim();
  }

  function normalizeLockerText(rawValue) {
    return normalizeLockerValue(rawValue).toLowerCase();
  }

  function getNestedLockerField(lockerInput) {
    if (!lockerInput || !lockerInput.querySelector) {
      return null;
    }

    return lockerInput.querySelector('input, select, textarea');
  }

  function isLockerFormField(element) {
    return !!(element && element.matches && element.matches('input, select, textarea'));
  }

  function getLockerValue(lockerInput) {
    if (!lockerInput) {
      return '';
    }

    var nestedLockerField = getNestedLockerField(lockerInput);
    var lockerField = isLockerFormField(lockerInput) ? lockerInput : nestedLockerField;

    if (lockerField) {
      return normalizeLockerValue(lockerField.value);
    }

    var candidateValues = [
      lockerInput.dataset && lockerInput.dataset.value,
      lockerInput.dataset && lockerInput.dataset.lockerId,
      lockerInput.dataset && lockerInput.dataset.selectedLockerId,
      lockerInput.getAttribute('data-value'),
      lockerInput.getAttribute('data-locker-id'),
      lockerInput.getAttribute('data-selected-locker-id'),
      lockerInput.textContent,
      lockerInput.innerText
    ];

    for (var index = 0; index < candidateValues.length; index += 1) {
      var normalizedValue = normalizeLockerValue(candidateValues[index]);

      if (normalizedValue) {
        return normalizedValue;
      }
    }

    return '';
  }

  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    var computedStyle = window.getComputedStyle(element);

    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
      return false;
    }

    return element.getClientRects().length > 0;
  }

  function isLockerDetailsVisible(lockerInput) {
    var lockerSelectionRoot = getLockerSelectionRoot(lockerInput);

    if (!lockerSelectionRoot || !lockerSelectionRoot.querySelector) {
      return true;
    }

    var lockerDetails = lockerSelectionRoot.querySelector(LOCKER_DETAILS_SELECTOR);

    if (!lockerDetails) {
      return true;
    }

    return isElementVisible(lockerDetails);
  }

  function isLockerDetailsExplicitlyHidden(lockerInput) {
    var lockerDetails = getLockerDetailsElement(lockerInput);

    if (!lockerDetails) {
      return false;
    }

    var computedStyle = window.getComputedStyle(lockerDetails);

    return computedStyle.display === 'none' || computedStyle.visibility === 'hidden';
  }

  function getLockerDetailsElement(lockerInput) {
    var lockerSelectionRoot = getLockerSelectionRoot(lockerInput);

    if (!lockerSelectionRoot || !lockerSelectionRoot.querySelector) {
      return null;
    }

    return lockerSelectionRoot.querySelector(LOCKER_DETAILS_SELECTOR);
  }

  function getDisabledClassName() {
    if (
      window.themeCore &&
      window.themeCore.utils &&
      window.themeCore.utils.cssClasses &&
      window.themeCore.utils.cssClasses.disabled
    ) {
      return window.themeCore.utils.cssClasses.disabled;
    }

    return FALLBACK_DISABLED_CLASS;
  }

  function getElementDatasetText(element) {
    if (!element || !element.dataset) {
      return '';
    }

    var datasetKeys = Object.keys(element.dataset);
    var datasetText = '';

    for (var index = 0; index < datasetKeys.length; index += 1) {
      datasetText += ' ' + element.dataset[datasetKeys[index]];
    }

    return datasetText;
  }

  function getKnownLockerLauncher() {
    for (var index = 0; index < KNOWN_LOCKER_LAUNCHER_SELECTORS.length; index += 1) {
      var lockerLauncher = document.querySelector(KNOWN_LOCKER_LAUNCHER_SELECTORS[index]);

      if (!lockerLauncher || lockerLauncher.matches(LOCKER_UNSELECT_BUTTON_SELECTOR)) {
        continue;
      }

      return lockerLauncher;
    }

    return null;
  }

  function scoreLockerLauncherCandidate(candidate) {
    if (!candidate || candidate.matches(LOCKER_UNSELECT_BUTTON_SELECTOR) || candidate.disabled) {
      return -1;
    }

    if (candidate.matches(LOCKER_MAP_BUTTON_SELECTOR) || candidate.matches(CHECKOUT_BUTTON_SELECTOR)) {
      return -1;
    }

    var candidateText = normalizeLockerText(candidate.textContent);
    var candidateMetadata = normalizeLockerText(
      [
        candidate.id,
        candidate.className,
        candidate.getAttribute('aria-label'),
        candidate.getAttribute('title'),
        getElementDatasetText(candidate)
      ].join(' ')
    );
    var score = 0;

    if (
      candidate.matches('button, [role="button"], a') ||
      candidate.getAttribute('type') === 'button'
    ) {
      score += 3;
    }

    if (candidateText.indexOf('unselect') !== -1 || candidateText.indexOf('reset') !== -1) {
      score -= 30;
    }

    if (candidateText.indexOf('box now') !== -1 || candidateText.indexOf('boxnow') !== -1) {
      score += 30;
    }

    if (candidateText.indexOf('locker') !== -1) {
      score += 12;
    }

    if (candidateText.indexOf('map') !== -1) {
      score += 10;
    }

    if (candidateText.indexOf('select') !== -1) {
      score += 8;
    }

    if (candidateText.indexOf('available') !== -1 || candidateText.indexOf('view') !== -1) {
      score += 6;
    }

    if (candidateMetadata.indexOf('boxnow') !== -1 || candidateMetadata.indexOf('box-now') !== -1) {
      score += 16;
    }

    if (candidateMetadata.indexOf('locker') !== -1) {
      score += 8;
    }

    if (candidateMetadata.indexOf('map') !== -1 || candidateMetadata.indexOf('widget') !== -1) {
      score += 8;
    }

    if (candidate.closest(LOCKER_SELECTION_SELECTOR)) {
      score += 6;
    }

    return score;
  }

  function findLockerLauncherByHeuristics() {
    if (!document.body || !document.body.querySelectorAll) {
      return null;
    }

    var lockerCandidates = document.body.querySelectorAll('button, [role="button"], a');
    var bestCandidate = null;
    var bestScore = 0;

    for (var index = 0; index < lockerCandidates.length; index += 1) {
      var candidate = lockerCandidates[index];
      var candidateScore = scoreLockerLauncherCandidate(candidate);

      if (candidateScore <= bestScore) {
        continue;
      }

      bestCandidate = candidate;
      bestScore = candidateScore;
    }

    return bestCandidate;
  }

  function getLockerLauncher() {
    return getKnownLockerLauncher() || findLockerLauncherByHeuristics();
  }

  function isLockerAppSectionMountedInModal(lockerAppSection) {
    var lockerModalContent = getLockerModalContent();

    if (!lockerModalContent || !lockerAppSection) {
      return false;
    }

    return lockerModalContent.contains(lockerAppSection);
  }

  function syncLockerAppPresentation() {
    var lockerAppSection = getLockerAppSection();
    var lockerLauncher = getLockerLauncher();
    var copyElements = null;

    if (!lockerAppSection || !lockerAppSection.querySelectorAll) {
      return;
    }

    copyElements = lockerAppSection.querySelectorAll('h1, h2, h3, h4, h5, h6, p');

    for (var index = 0; index < copyElements.length; index += 1) {
      var copyElement = copyElements[index];

      copyElement.classList.remove(LOCKER_APP_COPY_HIDDEN_CLASS);
    }

    if (lockerLauncher && lockerAppSection.contains(lockerLauncher)) {
      lockerLauncher.classList.remove('cart-locker-app-launcher--hidden');
      lockerLauncher.classList.add('button', 'button--secondary-border', 'button--block');

      if (lockerLauncher.matches('button') && !lockerLauncher.getAttribute('type')) {
        lockerLauncher.setAttribute('type', 'button');
      }
    }
  }

  function syncLockerAppSectionVisibility() {
    var lockerAppSection = getLockerAppSection();

    if (!lockerAppSection) {
      return;
    }

    lockerAppSection.classList.toggle(
      LOCKER_APP_SECTION_HIDDEN_CLASS,
      !isLockerAppSectionMountedInModal(lockerAppSection)
    );
  }

  function restoreLockerAppSection() {
    var lockerAppSection = getLockerAppSection();

    if (!lockerAppSection || !lockerAppSectionPlaceholder || !lockerAppSectionPlaceholder.parentNode) {
      syncLockerAppSectionVisibility();
      syncCartCtaState();
      return;
    }

    lockerAppSectionPlaceholder.parentNode.insertBefore(lockerAppSection, lockerAppSectionPlaceholder.nextSibling);
    lockerAppSection.classList.add(LOCKER_APP_SECTION_HIDDEN_CLASS);
    syncCartCtaState();
  }

  function ensureLockerModalToggle() {
    if (lockerModalToggle || !window.themeCore || !window.themeCore.utils || !window.themeCore.utils.Toggle) {
      return lockerModalToggle;
    }

    var lockerModal = getLockerModal();

    if (!lockerModal) {
      return null;
    }

    lockerModalToggle = window.themeCore.utils.Toggle({
      toggleSelector: lockerModal.id
    });
    lockerModalToggle.init();

    lockerModal.addEventListener('click', function (event) {
      if (event.target !== lockerModal || !lockerModalToggle) {
        return;
      }

      lockerModalToggle.close(lockerModal);
    });

    if (window.themeCore.EventBus && window.themeCore.EventBus.listen) {
      window.themeCore.EventBus.listen('Toggle:CartLockerModal:close', restoreLockerAppSection);
    }

    return lockerModalToggle;
  }

  function openLockerModal() {
    var lockerModal = getLockerModal();
    var lockerModalContent = getLockerModalContent();
    var lockerAppSection = getLockerAppSection();
    var lockerToggle = ensureLockerModalToggle();

    if (!lockerModal || !lockerModalContent || !lockerAppSection || !lockerToggle) {
      return false;
    }

    if (!lockerAppSectionPlaceholder || !lockerAppSectionPlaceholder.parentNode) {
      lockerAppSectionPlaceholder = document.createElement('div');
      lockerAppSectionPlaceholder.hidden = true;
      lockerAppSection.parentNode.insertBefore(lockerAppSectionPlaceholder, lockerAppSection);
    }

    lockerAppSection.classList.remove(LOCKER_APP_SECTION_HIDDEN_CLASS);
    lockerModalContent.appendChild(lockerAppSection);
    lockerToggle.open(lockerModal);
    window.setTimeout(function () {
      lockerModal.focus();
    }, 50);

    return true;
  }

  function hasLockerSelection() {
    var lockerInput = getLockerInput();
    var lockerAppSection = getLockerAppSection();
    var lockerValue = '';

    if (!lockerInput) {
      return false;
    }

    lockerValue = getLockerValue(lockerInput);

    if (!lockerValue) {
      return false;
    }

    if (!isLockerDetailsVisible(lockerInput)) {
      if (
        !lockerAppSection ||
        !lockerAppSection.classList.contains(LOCKER_APP_SECTION_HIDDEN_CLASS) ||
        isLockerDetailsExplicitlyHidden(lockerInput)
      ) {
        return false;
      }
    }

    return true;
  }

  function getSelectedLockerText(lockerInput) {
    var lockerDetails = getLockerDetailsElement(lockerInput);

    if (lockerDetails && lockerDetails.cloneNode) {
      var lockerDetailsClone = lockerDetails.cloneNode(true);
      var lockerUnselectButton = lockerDetailsClone.querySelector(LOCKER_UNSELECT_BUTTON_SELECTOR);
      var lockerText = '';

      if (lockerUnselectButton) {
        lockerUnselectButton.remove();
      }

      lockerText = normalizeLockerValue(lockerDetailsClone.textContent).replace(/\s+/g, ' ');
      lockerText = lockerText.replace(/^you have selected the following box now locker:\s*/i, '');
      lockerText = lockerText.replace(/^selected box now locker:\s*/i, '');
      lockerText = lockerText.replace(/^box now locker:\s*/i, '');

      if (lockerText) {
        return lockerText;
      }
    }

    return getLockerValue(lockerInput);
  }

  function getSelectedLockerSummary(lockerInput) {
    var lockerId = normalizeLockerValue(getLockerValue(lockerInput));
    var lockerText = normalizeLockerValue(getSelectedLockerText(lockerInput));

    if (!lockerId && !lockerText) {
      return '';
    }

    if (!lockerText) {
      return lockerId;
    }

    if (!lockerId) {
      return lockerText;
    }

    if (normalizeLockerText(lockerText).indexOf(normalizeLockerText(lockerId)) !== -1) {
      return lockerText;
    }

    return lockerId + ' - ' + lockerText;
  }

  function isTermsStateValid(cartSection) {
    var termsCheckbox = cartSection.querySelector(TERMS_CHECKBOX_SELECTOR);

    if (!termsCheckbox) {
      return true;
    }

    return termsCheckbox.checked;
  }

  function isMinimumOrderStateValid(cartSection) {
    var buttonMessage = cartSection.querySelector(BUTTON_MESSAGE_SELECTOR);

    if (!buttonMessage) {
      return true;
    }

    return !buttonMessage.classList.contains(getDisabledClassName());
  }

  function syncLockerMapButtonState() {
    var lockerMapButton = getLockerMapButton();

    if (!lockerMapButton) {
      return;
    }

    var lockerInput = getLockerInput();
    var lockerMapSummary = getLockerMapSummary();
    var lockerLauncher = getLockerLauncher();
    var hasSelection = hasLockerSelection();
    var selectedLockerSummary = hasSelection ? getSelectedLockerSummary(lockerInput) : '';
    var lockerLabel = hasSelection
      ? lockerMapButton.getAttribute('data-selected-label')
      : lockerMapButton.getAttribute('data-default-label');
    var lockerMapButtonLabel = lockerMapButton.querySelector(LOCKER_MAP_BUTTON_LABEL_SELECTOR);
    var isDisabled = !lockerLauncher;

    if (lockerMapButtonLabel) {
      lockerMapButtonLabel.textContent = lockerLabel;
    } else if (lockerLabel) {
      lockerMapButton.textContent = lockerLabel;
    }

    lockerMapButton.disabled = isDisabled;
    lockerMapButton.setAttribute('aria-disabled', String(isDisabled));
    lockerMapButton.title = selectedLockerSummary || lockerLabel || '';

    if (lockerMapSummary) {
      lockerMapSummary.hidden = !selectedLockerSummary;
      lockerMapSummary.textContent = selectedLockerSummary;
    }
  }

  function syncCheckoutButtonState() {
    var cartSection = getCartSection();
    var checkoutButton = getCheckoutButton();

    syncLockerMapButtonState();

    if (!cartSection || !checkoutButton) {
      return;
    }

    var hasLocker = hasLockerSelection();
    var isTermsValid = isTermsStateValid(cartSection);
    var isMinimumValid = isMinimumOrderStateValid(cartSection);
    var isEnabled =
      hasLocker &&
      isTermsValid &&
      isMinimumValid;

    checkoutButton.disabled = !isEnabled;
    checkoutButton.setAttribute('aria-disabled', String(!isEnabled));
  }

  function syncCartCtaState() {
    syncCheckoutButtonState();
  }

  function disableCheckoutButton() {
    var checkoutButton = getCheckoutButton();

    if (!checkoutButton) {
      return;
    }

    checkoutButton.disabled = true;
    checkoutButton.setAttribute('aria-disabled', 'true');
  }

  function queueSync() {
    if (syncQueued) {
      return;
    }

    syncQueued = true;

    window.requestAnimationFrame(function () {
      syncQueued = false;
      syncLockerInputBinding();
    });
  }

  function preventInvalidCheckout(event) {
    var checkoutButton = event.target.closest(CHECKOUT_BUTTON_SELECTOR);

    if (!checkoutButton || hasLockerSelection()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    queueSync();
  }

  function preventInvalidCheckoutSubmit(event) {
    var submitter = event.submitter;

    if (!submitter || !submitter.matches(CHECKOUT_BUTTON_SELECTOR)) {
      return;
    }

    if (hasLockerSelection()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    queueSync();
  }

  function openLockerMap(event) {
    var lockerMapButton = event.target.closest(LOCKER_MAP_BUTTON_SELECTOR);

    if (!lockerMapButton) {
      return;
    }

    event.preventDefault();

    var lockerLauncher = getLockerLauncher();

    if (!lockerLauncher) {
      queueSync();
      return;
    }

    if (openLockerModal()) {
      window.setTimeout(function () {
        var modalLockerLauncher = getLockerLauncher();

        if (modalLockerLauncher) {
          modalLockerLauncher.click();
        }
      }, 50);

      return;
    }

    lockerLauncher.click();
  }

  function bindEvents() {
    document.addEventListener('click', preventInvalidCheckout, true);
    document.addEventListener('submit', preventInvalidCheckoutSubmit, true);
    document.addEventListener('click', openLockerMap);
    document.addEventListener('click', function (event) {
      if (!event.target.closest(LOCKER_UNSELECT_BUTTON_SELECTOR)) {
        return;
      }

      disableCheckoutButton();
      window.setTimeout(queueSync, 50);
      window.setTimeout(queueSync, 250);
    });

    document.addEventListener('input', function (event) {
      if (
        event.target.matches(LOCKER_INPUT_SELECTOR) ||
        event.target.matches(TERMS_CHECKBOX_SELECTOR)
      ) {
        queueSync();
      }
    });

    document.addEventListener('change', function (event) {
      if (
        event.target.matches(LOCKER_INPUT_SELECTOR) ||
        event.target.matches(TERMS_CHECKBOX_SELECTOR)
      ) {
        queueSync();
      }
    });
  }

  function bindLockerInput(lockerInput) {
    if (!lockerInput || lockerInput.__customLockerBound) {
      observeLockerMutations(lockerInput);
      return;
    }

    lockerInput.__customLockerBound = true;
    observeLockerMutations(lockerInput);

    lockerInput.addEventListener('input', syncCartCtaState);
    lockerInput.addEventListener('change', syncCartCtaState);

    var prototype = Object.getPrototypeOf(lockerInput);
    var valueDescriptor = Object.getOwnPropertyDescriptor(prototype, 'value');

    if (!valueDescriptor || !valueDescriptor.configurable || !valueDescriptor.set || !valueDescriptor.get) {
      return;
    }

    Object.defineProperty(lockerInput, 'value', {
      configurable: true,
      enumerable: valueDescriptor.enumerable,
      get: function () {
        return valueDescriptor.get.call(this);
      },
      set: function (value) {
        valueDescriptor.set.call(this, value);
        queueSync();
      }
    });
  }

  function observeLockerMutations(lockerInput) {
    var lockerObservationRoot = getLockerSelectionRoot(lockerInput);

    if (!lockerObservationRoot) {
      if (lockerMutationObserver) {
        lockerMutationObserver.disconnect();
      }

      observedLockerNode = null;
      return;
    }

    if (observedLockerNode === lockerObservationRoot) {
      return;
    }

    if (lockerMutationObserver) {
      lockerMutationObserver.disconnect();
    }

    observedLockerNode = lockerObservationRoot;
    lockerMutationObserver = new MutationObserver(queueSync);
    lockerMutationObserver.observe(lockerObservationRoot, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function syncLockerInputBinding() {
    syncLockerAppSectionVisibility();
    syncLockerAppPresentation();
    bindLockerInput(getLockerInput());
    syncCartCtaState();
  }

  function isRelevantNode(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (
      node.matches(CART_SECTION_SELECTOR) ||
      node.matches(CHECKOUT_BUTTON_SELECTOR) ||
      node.matches(LOCKER_INPUT_SELECTOR) ||
      node.matches(LOCKER_SELECTION_SELECTOR) ||
      node.matches(TERMS_CHECKBOX_SELECTOR) ||
      node.matches(BUTTON_MESSAGE_SELECTOR) ||
      node.matches(LOCKER_MAP_BUTTON_SELECTOR)
    ) {
      return true;
    }

    return !!node.querySelector(
      [
        CART_SECTION_SELECTOR,
        CHECKOUT_BUTTON_SELECTOR,
        LOCKER_INPUT_SELECTOR,
        LOCKER_SELECTION_SELECTOR,
        TERMS_CHECKBOX_SELECTOR,
        BUTTON_MESSAGE_SELECTOR,
        LOCKER_MAP_BUTTON_SELECTOR
      ]
        .concat(KNOWN_LOCKER_LAUNCHER_SELECTORS)
        .join(', ')
    );
  }

  function shouldSyncForMutations(mutations) {
    for (var index = 0; index < mutations.length; index += 1) {
      var mutation = mutations[index];

      if (mutation.target && isRelevantNode(mutation.target)) {
        return true;
      }

      for (var addIndex = 0; addIndex < mutation.addedNodes.length; addIndex += 1) {
        if (isRelevantNode(mutation.addedNodes[addIndex])) {
          return true;
        }
      }

      for (var removeIndex = 0; removeIndex < mutation.removedNodes.length; removeIndex += 1) {
        if (isRelevantNode(mutation.removedNodes[removeIndex])) {
          return true;
        }
      }
    }

    return false;
  }

  function observeDomChanges() {
    var observer = new MutationObserver(function (mutations) {
      if (shouldSyncForMutations(mutations)) {
        queueSync();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function bindCartEvents() {
    if (!window.themeCore || !window.themeCore.EventBus) {
      return;
    }

    window.themeCore.EventBus.listen('cart:updated', queueSync);
    window.themeCore.EventBus.listen('cart:refresh', queueSync);
  }

  function init() {
    ensureLockerModalToggle();
    bindEvents();
    bindCartEvents();
    syncLockerInputBinding();
    observeDomChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
